import { useState } from "react";

const ProgressBar = ({ value, onSeekStart, onSeekEnd, onSeeking }) => {

    const [isDragging, setIsDragging] = useState(false);

    const handleSeekStart = () => {
        console.log("handleSeekStart");
        setIsDragging(true);
        onSeekStart && onSeekStart();
    };

    const handleSeekEnd = (event) => {
        console.log("handleSeekEnd");
        setIsDragging(false);
        onSeekEnd && onSeekEnd(parseInt(event.target.value, 10));
    };

    const handleChange = (event) => {
        console.log("handleChange");
        if (isDragging) {
            onSeeking && onSeeking(parseInt(event.target.value, 10));
        }
    };

    return (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <input
                type="range"
                min="0"
                max="100"
                value={value}
                step="1"
                onMouseDown={handleSeekStart}
                onMouseUp={handleSeekEnd}
                onTouchStart={handleSeekStart}
                onTouchEnd={handleSeekEnd}
                onChange={handleChange}
                style={{
                    appearance: "none",
                    background: `linear-gradient(to right, #FFFFFFff ${value}%, #FFFFFF51 ${value}%)`,
                    height: "5px",
                    borderRadius: "2.5px",
                    outline: "none",
                    flexGrow: 1,
                    margin: "10px",
                }}
            />
            <style>{`
                        input[type="range"]::-webkit-slider-thumb {
                          appearance: none;
                          width: 12px;
                          height: 12px;
                          background: #fff;
                          border-radius: 50%;
                          cursor: pointer;
                        }
                        input[type="range"]::-moz-range-thumb {
                          width: 12px;
                          height: 12px;
                          background: #fff;
                          border-radius: 50%;
                          cursor: pointer;
                        }
      `}</style>
        </div>
    );
};

export default ProgressBar;
